import { styled } from "@mui/styles"

const InputFile = styled((props) => <input type="file" {...props} />)(({ theme }) => ({
  height: "0px",
  width: "0px",
  display: "none"
}))

export default InputFile
